export default __webpack_public_path__ + "static/media/ic_arrow_up.05dc1ce5.svg";